import http from "./base";

export default {
    index(queryString) {
        return http().get('/movies' + (queryString !== undefined ? '?' + queryString : ''))
    },
    show(id) {
        return http().get('/movies/' + id)
    },
    deleteMovieMaterial(movieId, materialId) {
        return http().delete('movies/' + movieId + '/material/' + materialId)
    },
    getMonitoringRevenues() {
        return http().get('/monitoring-revenues')
    },
    getReports() {
        return http().get('/movies-reports')
    },
    getReportFile(reportId) {
        return http({
            timeout: -1,
            responseType: 'blob'
        }).get('movie-reports/' + reportId)
    },
    deleteInvoice(reportId) {
        return http().delete('movie-reports/' + reportId + '/invoice')
    },
}
